import {
	Checkbox,
	FormControl,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
} from "@mui/material";
import { ChemistryElement } from "../../../models/ChemistryRange";

type Props = {
	elements: ChemistryElement[];
	visible: string[];
	used: Set<string>;
	onToggle: (elementName: string) => void;
};

export const ColumnsMenu = ({ elements, visible, used, onToggle }: Props) => (
	<FormControl size="small" sx={{ minWidth: 160 }}>
		<InputLabel id="chemistry-columns-label" shrink>
			Columns
		</InputLabel>
		<Select
			multiple
			notched
			displayEmpty
			labelId="chemistry-columns-label"
			label="Columns"
			value={visible}
			data-test-id="columns-button"
			onChange={(e) => {
				const next = e.target.value as string[];
				const toggled =
					next.find((name) => !visible.includes(name)) ??
					visible.find((name) => !next.includes(name));
				if (toggled) onToggle(toggled);
			}}
			renderValue={(selected) => `${selected.length} of ${elements.length}`}
			sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
			MenuProps={{
				slotProps: {
					paper: { sx: { maxHeight: 420 } },
				},
			}}
		>
			{elements.map((element) => (
				<MenuItem
					key={element.ElementId}
					dense
					value={element.ElementName}
					data-test-id={`column-toggle-${element.ElementName.toLowerCase()}`}
				>
					<Checkbox
						size="small"
						checked={visible.includes(element.ElementName)}
						sx={{ p: 0, mr: 1 }}
					/>
					<ListItemText
						primary={
							element.Description
								? `${element.ElementName} - ${element.Description}`
								: element.ElementName
						}
						secondary={used.has(element.ElementName) ? null : "no values"}
						slotProps={{ secondary: { variant: "caption" } }}
					/>
				</MenuItem>
			))}
		</Select>
	</FormControl>
);
